/**
* Treatment Cards JS
* -----------------------------------------------------------------------------
*
* All the JS for the Treatment Cards component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

/**
* Treatment Cards JS
* -----------------------------------------------------------------------------
*
* All the JS for the Treatment Cards component.
*/

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';

( function( app ) {
  const COMPONENT = {
    className: 'treatment-cards',
    selector: function() {
      return '.' + this.className;
    },

    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      let isScrollMode = null;
      let sliderInitialized = false;

      const scroller = document.querySelector( '.treatment-cards__scroller' );
      const treatmentCards = document.querySelectorAll( '.treatment' );
      const cardWidth = treatmentCards[0] ? treatmentCards[0].offsetWidth : 0;

      const enableScrollAnimation = () => {
        const numberOfCards = treatmentCards.length;
        const scrollDistance = ( cardWidth * numberOfCards / 5 );

        gsap.fromTo(
            scroller,
            {x: 0},
            {
              x: -scrollDistance,
              ease: 'power1.out',
              scrollTrigger: {
                trigger: '.treatment-cards',
                start: () => `top top+=${$( 'header' ).height() || 0}px`,
                end: () => `+=${scrollDistance}`,
                scrub: 2,
                pin: true,
              },
            }
        );
      };

      const enableSlider = () => {
        if ( !sliderInitialized ) {
          $( '.treatment-cards__slider' ).slick( {
            dots: false,
            arrows: true,
            prevArrow: $( '.treatment-cards' ).find( '.prev-slide' )[0],
            nextArrow: $( '.treatment-cards' ).find( '.next-slide' )[0],
            slidesToShow: 1,
            slidesToScroll: 1,
          } );
          sliderInitialized = true;
        }
      };

      const destroySlider = () => {
        if ( sliderInitialized ) {
          $( '.treatment-cards__slider' ).slick( 'unslick' );
          sliderInitialized = false;
        }
      };

      const updateLayoutMode = () => {
        const isDesktop = window.matchMedia( '(min-width: 1024px)' ).matches;

        if ( isDesktop && isScrollMode !== true ) {
          destroySlider();
          enableScrollAnimation();
          isScrollMode = true;
        }

        if ( !isDesktop && isScrollMode !== false ) {
          enableSlider();
          isScrollMode = false;
        }
      };

      updateLayoutMode();

      window.addEventListener( 'resize', () => {
        updateLayoutMode();
      } );

      $( '.treatment-cards__marquee' ).slick( {
        autoplay: true,
        speed: 8000,
        autoplaySpeed: 8000,
        centerMode: true,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: true,
        arrows: false,
        buttons: false,
        pauseOnHover: false,
      } );
    },

    finalize: function() {},
  };

  // Register the component
  app.registerComponent( 'treatment-cards', COMPONENT );
} )( app );
